


















































































import Mixins, { SelectOption } from './mixin'

import { FindSVG } from '@/api/svg'

// eslint-disable-next-line
import 'verte/dist/verte.css'
const Verte = require('verte').default

export default Mixins.extend({
  name: 'TrendEditor',
  components: {
    Verte,
  },
  data() {
    return {
      optsSVG: [] as SelectOption[],
    }
  },
  computed: {},
  methods: {
    async find() {
      const svgs = await FindSVG()
      for (const key in svgs) {
        this.optsSVG.push({ text: svgs[key].name, value: svgs[key].uid })
      }
    },
  },
  async created() {
    await this.find()
    this.parseInput()
  },
})
